// extracted by mini-css-extract-plugin
export default {"gridDesktop":"aykMN","gridDesktopTrends":"i77an","gridDesktopM":"Bne0n","gridDesktopMTrends":"dMD4P","cardDesktopM":"bmJAw"};